document.addEventListener('teeinblue-event-after-cart-added', async function() {
  const response = await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      sections: 'cart_data,mini_cart',
      sections_url: window.location.pathname,
    })
  });

  const data = await response.json();

  T4SThemeSP.Cart.renderContents(data.sections);

  const cartIcon = document.querySelector('.t4s-site-nav__cart > a');

  if (cartIcon) {
    cartIcon.click();
  }
});